import { Box } from '@mui/material';
import Button from '../../../../../components/Button/Button';
import EnabledActionsComponent from '../../../Roles/components/RolePermissionsComponent';

function UserDocTypes({ copyPermissions, copyPermissionsButtonValidation, ...props }: any) {
    return (
        <Box mb={5}>
            {props?.drawerAction === 'new' && (
                <Box mb={1} justifyContent="flex-end" display="flex">
                    <Button
                        onClick={copyPermissions}
                        disabled={copyPermissionsButtonValidation}
                        style={{
                            textTransform: 'none',
                            borderRadius: '8px',
                            background: 'transparent',
                            color: '#004B81'
                        }}
                    >
                        Copiar permisos del rol
                    </Button>
                </Box>
            )}
            <EnabledActionsComponent {...props} />
        </Box>
    );
}

export default UserDocTypes;
